module.exports = __webpack_public_path__ + "img/flushed_face.ed142149.gif";